import { ArnLogger, logMethod } from './ArnLogger';
import { ArnLogLevel, ArnValidLogConfig } from '@arianee/arn-types';

export interface ConsoleLogConfig extends ArnValidLogConfig {
  console: LogConsole;
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
const NOP = () => {};

export interface LogConsole {
  log(...data: any[]): void;

  debug(...data: any[]): void;

  warn(...data: any[]): void;

  error(...data: any[]): void;
}

export class DefaultLogger implements ArnLogger {
  readonly name: string;
  readonly info: logMethod;
  readonly debug: logMethod;
  readonly warn: logMethod;
  readonly error: logMethod;

  constructor(protected config: ConsoleLogConfig) {
    const { name, logLevels, console } = this.config;
    this.name = name;
    this.info = logLevels.includes(ArnLogLevel.info)
      ? (...data: any[]) => console.log(name + ':', ...data)
      : NOP;
    this.debug = logLevels.includes(ArnLogLevel.debug)
      ? (...data: any[]) => console.debug(name + ':', ...data)
      : NOP;
    this.warn = logLevels.includes(ArnLogLevel.warn)
      ? (...data: any[]) => console.warn(name + ':', ...data)
      : NOP;
    this.error = logLevels.includes(ArnLogLevel.error)
      ? (...data: any[]) => console.error(name + ':', ...data)
      : NOP;
  }

  fork(subName: string, nest = true): ArnLogger {
    return new (class extends DefaultLogger {})({
      ...this.config,
      name: nest ? `${this.name}:${subName}` : subName,
    });
  }
}
